import changeByEmail from './changeByEmail';
import passConfigGet from './passConfigGet';
import passConfigGetByEmail from './passConfigGetByEmail';
import phoneUpdate from './phoneUpdate';
import validateCode from './validateCode';
import passIsLegal from './passIsLegal';

export default {
  changeByEmail,
  passConfigGet,
  passConfigGetByEmail,
  phoneUpdate,
  validateCode,
  passIsLegal,
};

export interface PassConfig {
  passLetterMin: number;
  passLowerMin: number;
  passMinLength: number;
  passNumMin: number;
  passOtherMim: number;
  passUpperMim: number;
}


// WEBPACK FOOTER //
// ./src/api/passwordRule/index.ts